import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexReactClient } from "convex/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";

import { AuthGuard } from "@/AuthGuard";
import { ReviewTimeProvider } from "@/hooks/useReviewTime";
import { PWABadge } from "@/pwa/PWABadge";
import { PwaBadgeUpdater } from "@/pwa/PwaBadgeUpdater";
import { routes } from "@/routes";

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);

const router = createBrowserRouter(routes);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- there's no need to check this -- the app will definitely blow up if it doesn't exist.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ReviewTimeProvider>
      <ConvexAuthProvider client={convex}>
        <AuthGuard>
          <>
            <PwaBadgeUpdater />
            <RouterProvider router={router} />
          </>
        </AuthGuard>
      </ConvexAuthProvider>
    </ReviewTimeProvider>
    <PWABadge />
  </StrictMode>
);
